import { faEye, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Col, Form, Row, Table } from "react-bootstrap";
import Componente from "./Componentes";
import PrazoPagto from "./PrazoPagto";
import { formatMoeda, handleNumberOnly, strToFloat, validarCNPJ, validarCPFCNPJ } from "../../../utils/utils";
import { useState } from "react";
import { infPagInterface } from "../../../interfaces";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { JConfirmDelete, MensagemModal } from "../../../components/Components";
import { addInfPag, removeInfPag } from "../../../features/manifestoSlice";

const initialForm: infPagInterface = {
    id: 0,
    CNPJIPEF: '',
    codAgencia: '',
    codBanco: '',
    cpfcnpj: '',
    idestrangeiro: false,
    indPag: 0,
    PIX: '',
    vContrato: 0,
    comp: [],
    infPrazo: [],
    indAltoDesemp: 0,
    indAntecipaAdiant: 0,
    tpAntecip: 0,
    vAdiant: 0,
    xNome: ''
}

export default function InfPagFrete() {
    const dispatch = useDispatch();
    const listaPagFretes = useSelector((state: RootState) => state.manifesto.manifesto.modal_rodoviario.infANTT?.infPag);
    const [form, setForm] = useState<infPagInterface>(initialForm)
    const [showModal, setShowModal] = useState<boolean>(false);
    const [selected, setSelected] = useState<number>(0);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [messageAlert, setMessageAlert] = useState<string>('');

    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(0);
    }

    const handleOpenModal = (id: number) => {
        setSelected(id);
        setShowModal(true);
    }

    const validaPreenchimento = () => {
        if (form.cpfcnpj.trim() === "") {
            alerta('Informe o CPF/CNPJ.');
            return false;
        }

        if (!form.idestrangeiro) {

            if (!validarCPFCNPJ(form.cpfcnpj.trim())) {
                alerta('CPF/CNPJ inválido.');
                return false;
            }
        }

        if (form.codBanco.trim() === "") {
            alerta('Informe o Cod. Banco');
            return false;
        }

        if (form.codAgencia.trim() === "") {
            alerta('Informe o Cod. Agencia');
            return false;
        }

        if (form.CNPJIPEF.trim() === "" && form.PIX === "") {
            alerta('Informe o CNPJ Inst. Pagto Ou a chave PIX.');
            return false;
        }

        if (form.CNPJIPEF.trim() !== "" && !validarCNPJ(form.CNPJIPEF.trim())) {
            alerta('CNPJ inválido.');
            return false;
        }

        if (form.comp?.length === 0) {
            alerta('Informe pelo menos um componente');
            return false;
        }

        return true;
    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleChangeNumeric = (e: any) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: strToFloat(value)
        }))
    }

    const handleAdd = () => {
        if (validaPreenchimento()) {
            dispatch(addInfPag(form));
            setForm(initialForm);
        }
    }

    const handleRemove = (id: number) => {
        dispatch(removeInfPag(id));
        setShowModal(false);
    }

    const checkCom = () => {
        if (form.comp === undefined) {
            return false;
        } else {
            if (form.comp?.length > 0) {
                return true
            }
        }
        return false;
    }

    const checkPrazo = () => {
        if (form.infPrazo === undefined) {
            return false;
        } else {
            if (form.infPrazo?.length > 0) {
                return true
            }
        }
        return false;
    }

    const checkValorContrato = () => {
        if (checkCom() || checkPrazo()) {
            return true;
        }

        return false;
    }

    const checkPrazoPagto = () => {
        if (form.infPrazo === undefined) {
            return false;
        } else {
            if (form.infPrazo.length > 0) {
                return true;
            }
        }

        return false;
    }

    return (<>
        <div className="row g-3">
            <Card className="card-primary card-outline mb-3">
                <Card.Body className="px-1"
                >
                    <Row>
                        <Col md className="border-end">
                            <Row className="mb-3 g-2">

                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label>CPF/CNPJ</Form.Label>
                                        <Form.Control value={form.cpfcnpj} name="cpfcnpj"
                                            onChange={handleChange} onKeyUp={handleNumberOnly} maxLength={20} />
                                    </Form.Group>
                                </Col>

                                <Col md={3} className="d-flex align-items-end ">
                                    <Form.Group controlId="active">
                                        <Form.Switch className="mb-0" type="switch" name="active" label="Estrangeiro?" />
                                    </Form.Group>
                                </Col>

                                <Col md>
                                    <Form.Group>
                                        <Form.Label>Nome</Form.Label>
                                        <Form.Control value={form.xNome} onChange={handleChange} maxLength={60}
                                            name="xNome" />
                                    </Form.Group>
                                </Col>

                            </Row>

                            <Row className="mb-3 g-2">
                                <Col md>
                                    <Form.Group>
                                        <Form.Label>Ind. Forma Pagto</Form.Label>
                                        <Form.Select value={form.indPag} name="indPag" disabled={checkPrazoPagto()}
                                            onChange={handleChange}>
                                            <option value="0">À vista</option>
                                            <option value="1">À prazo</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md>
                                    <Form.Group>
                                        <Form.Label>Valor Adiantamento</Form.Label>
                                        <Form.Control value={form.vAdiant} min={0} type="number" name="vAdiant"
                                            onChange={handleChangeNumeric}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md>
                                    <Form.Group>
                                        <Form.Label>Valor Contrato</Form.Label>
                                        <Form.Control value={form.vContrato} min={0} type="number" name="vContrato"
                                            onChange={handleChangeNumeric} disabled={checkValorContrato()}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row className="mb-3 g-2">
                                <Col md>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Tipo Antecipação</Form.Label>
                                        <Form.Select value={form.tpAntecip} name="tpAnticip"
                                            onChange={handleChange}>
                                            <option value="0">0 - Não permite antecipar</option>
                                            <option value="1">1 - Permite antecipar as parcelas</option>
                                            <option value="2">
                                                2 - Permite antecipar as parcelas mediante confirmação
                                            </option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md className="d-flex align-items-end mb-3 ">
                                    <Form.Group controlId="active">
                                        <Form.Switch className="mb-0" type="switch" name="indAltoDesemp"
                                            label="Alto Desempenho?" />
                                    </Form.Group>
                                </Col>

                                <Col md className="d-flex align-items-end mb-3">
                                    <Form.Group controlId="active">
                                        <Form.Switch className="mb-0" type="switch" name="indAntecipaAdiant"
                                            label="Pode Antecipar?" />
                                    </Form.Group>
                                </Col>

                            </Row>

                            <Row className="mb-3 g-2">
                                <Col md={2}>
                                    <Form.Group>
                                        <Form.Label>Cod Banco</Form.Label>
                                        <Form.Control value={form.codBanco} maxLength={5} name="codBanco"
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={2}>
                                    <Form.Group>
                                        <Form.Label>Cod Agencia</Form.Label>
                                        <Form.Control value={form.codAgencia} maxLength={10} name="codAgencia"
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md>
                                    <Form.Group>
                                        <Form.Label>CNPJ Inst. Pagto Frete</Form.Label>
                                        <Form.Control value={form.CNPJIPEF} maxLength={14} name="CNPJIPEF"
                                            onKeyUp={handleNumberOnly} onChange={handleChange} />
                                    </Form.Group>
                                </Col>

                                <Col md>
                                    <Form.Group>
                                        <Form.Label>Chave Pix</Form.Label>
                                        <Form.Control value={form.PIX} maxLength={60} name="PIX"
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={'auto'} className="d-flex align-items-end">
                                    <Button onClick={handleAdd} title="Adicionar na lista">
                                        <FontAwesomeIcon icon={faPlus} /> Adicionar
                                    </Button>
                                </Col>

                            </Row>


                        </Col>

                        <Col md>

                            <Row>

                                <Col md>
                                    <div className="nav nav-underline" id="v-pills-tab" role="tablist">
                                        <button className="nav-link active" id="tab1-tab" data-bs-toggle="pill"
                                            data-bs-target="#tab1" type="button" role="tab"
                                        >
                                            Componentes
                                        </button>
                                        <button className="nav-link" id="tab2-tab" data-bs-toggle="pill"
                                            data-bs-target="#tab2" type="button" role="tab">Prazo Pagto</button>
                                    </div>

                                    <div className="tab-content pt-2 px-2" id="v-pills-tabContent">
                                        <div className="tab-pane fade show active" id="tab1" role="tabpanel">
                                            <Componente form={form} setForm={setForm} />
                                        </div>
                                        <div className="tab-pane fade" id="tab2" role="tabpanel" >
                                            <PrazoPagto form={form} setForm={setForm} />
                                        </div>

                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <JConfirmDelete
                showModal={showModal}
                handleCloseModal={handleCloseModal}
                handleDelete={handleRemove}
                selectedObject={''}
                id={selected}
            />

            <MensagemModal
                show={showAlert}
                handleClose={() => setShowAlert(false)}
                mensagem={messageAlert}
            />
        </div>

        <Row className="" >
            <Col md>
                <Table striped bordered hover size="sm">
                    <thead className="table-light">
                        <tr>
                            <th className="text-center" style={{ width: '4rem' }}>#</th>
                            <th>Nome</th>
                            <th>CPF/CNPJ</th>
                            <th>Valor do Contrato</th>
                        </tr>
                    </thead>
                    <tbody>
                        {listaPagFretes?.map((item: infPagInterface) => (
                            <tr key={item.id}>
                                <td className="d-flex justify-content-around ">
                                    <a href="javasctipt:void(0)" className="text-danger"
                                        title="Remover" onClick={() => handleOpenModal(item.id)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </a>
                                    <a href="javasctipt:void(0)" className="text-success" title="Visualizar"
                                        onClick={() => window.alert('Visualizar componentes e prazo pagto')}>
                                        <FontAwesomeIcon icon={faEye} />
                                    </a>
                                </td>
                                <td>{item.xNome}</td>
                                <td>{item.cpfcnpj}</td>
                                <td>{formatMoeda(item.vContrato)}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Col>
        </Row>

    </>)
}
